import { TextField } from '@ori-ui/mui';
import { useContext } from 'react';

import { stateContext } from '../../contexts';
import { useTranslations } from '../../hooks/useTranslations';

export function FirstName() {
  const { formatMessage } = useTranslations();
  const { newCustomer, setCustomerName } = useContext(stateContext);

  return (
    <TextField
      fullWidth
      required
      value={newCustomer?.firstName ?? ''}
      type="text"
      name="name"
      label={formatMessage('Name')}
      variant="standard"
      onChange={setCustomerName}
    />
  );
}
